import React, { useState,Component } from 'react';
import axios from 'axios';
import { setUserSession } from '../utils/Common';
import { BrowserRouter, Switch, Route, NavLink } from 'react-router-dom';
import {Footer} from 'react-materialize';
import DataService from "../services/data.service";
import Message from '../component/Message';
import Loading from '../component/loading';
import { withRouter } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'

class Expiry_page extends Component {
  constructor(props) {
    super(props);

    this.state = {
    
     
    }
   
   
  }

    render() {
			return (

        <div id="popup1" class="overlay_cus_suceess">
        <div class="message_popup_loading">
            <h3 class="futura">Oh Snap!</h3>
            {/* <a class="close hand" onClick={props.handle_message}>&times;</a> */}
            <div class="content text-center mt-5 futura">
            It looks like the link you are trying to reach has expired. Please contact our fur specialists at Service@NMFurServices.com <br></br>or <br></br>call 1-888-765-3877 for assistance.</div>
                   
        </div>
        </div>
          );
    }
  
}
export default withRouter(Expiry_page);
